import { PublicSiteSchema } from "../../models/site.schema";

export const SiteControllerResponseSchema = {
  getPublicSite: PublicSiteSchema.nullable(),
};
